/* Meta Pixel custom event: honest_click (an event Meta already accepts for this pixel;
   brand-new event names get blocked by Meta for this pixel's data-source category).
   Sent exactly like snippets/scripts.liquid sends it: a bare fbq('trackCustom', name),
   guarded by the SAME sessionStorage key, so it fires at most ONCE per browser session
   no matter whether it comes from here or from the Add-to-cart click in scripts.liquid.

   v6 (tightened, based on MIDA "Engaged visitors" of the live ad campaign): honest_click
   now means an engaged visit. It fires once per browser session, the moment BOTH are true:
     1. ACTIVE time on the site >= MIN_ACTIVE_SECONDS (60 s). Active = tab visible AND the
        visitor scrolled / touched / moved / typed within the last IDLE_MS. Idle or
        backgrounded time does not count. Accumulates across pages of the visit.
     2. Viewed >= MIN_PAGES (3) different pages in the visit, the landing page included.
   Add to cart (scripts.liquid) still fires it too.
   A completed share of the rendered preview (share-urn-row.liquid -> window.__swHonestClick) fires it too.
   Nothing about the visitor, the product or anything typed is sent to Meta, only the bare
   event name. Tune the two constants below to loosen or tighten it.
   Runs on every page (needed to count pages and time).
   Config comes from snippets/customize-event.liquid as window.__swCustomize.
   Add ?sw_debug=1 to the URL to log progress in the browser console. */
(function () {
  var cfg = window.__swCustomize;
  if (!cfg || !cfg.pixelId || window.__swCustomizeReady) return;
  window.__swCustomizeReady = true;

  var EVENT_NAME = 'honest_click';
  var ONCE_KEY = 'sw_engaged_fired_honest_click'; /* same key scripts.liquid uses */
  var MIN_ACTIVE_SECONDS = 60;
  var MIN_PAGES = 3;
  var TICK_MS = 5000;
  var IDLE_MS = 10000;
  var K = { active: 'sw_hc_active_s', paths: 'sw_hc_paths' };
  var debug = /[?&]sw_debug=1/.test(location.search);
  var fired = false;
  var lastActivity = Date.now();

  function store(key, value) {
    try {
      if (arguments.length > 1) sessionStorage.setItem(key, value);
      else return sessionStorage.getItem(key);
    } catch (e) {}
    return null;
  }

  function num(key) {
    return parseInt(store(key) || '0', 10) || 0;
  }

  function marketingAllowed() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.marketingAllowed === 'function') return cp.marketingAllowed() !== false;
    } catch (e) {}
    return true;
  }

  function loadFbq() {
    if (window.fbq) return;
    var n = (window.fbq = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
    });
    if (!window._fbq) window._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    var s = document.createElement('script');
    s.async = true;
    s.src = 'https://connect.facebook.net/en_US/fbevents.js';
    var first = document.getElementsByTagName('script')[0];
    first.parentNode.insertBefore(s, first);
  }

  function send() {
    if (fired) return;
    fired = true;
    if (store(ONCE_KEY)) return;
    if (!marketingAllowed()) return;
    try {
      loadFbq();
      if (!window.__swFbInit) {
        window.__swFbInit = true;
        window.fbq('init', cfg.pixelId);
      }
      window.fbq('trackCustom', EVENT_NAME);
      store(ONCE_KEY, '1');
      if (debug) console.log('[honest_click sent]');
    } catch (e) {}
  }

  /* Called by the share button (snippets/share-urn-row.liquid) when a visitor completes sharing the RENDERED preview
     (the picture with their engraving on the urn). Same bare event and the same once-per-session key as above, so it
     can never fire twice in a visit, whichever way it started. */
  window.__swHonestClick = function (reason) {
    try {
      if (store(ONCE_KEY)) return;
      if (!marketingAllowed()) return;
      loadFbq();
      if (!window.__swFbInit) {
        window.__swFbInit = true;
        window.fbq('init', cfg.pixelId);
      }
      window.fbq('trackCustom', EVENT_NAME);
      store(ONCE_KEY, '1');
      fired = true;
      try { if (typeof window.clarity === 'function') window.clarity('set', 'sw_honest_click', reason || 'share'); } catch (e) {}
      if (debug) console.log('[honest_click sent: ' + (reason || 'share') + ']');
    } catch (e) {}
  };

  function readPaths() {
    var paths = [];
    try {
      paths = JSON.parse(store(K.paths) || '[]');
    } catch (e) {}
    return paths;
  }

  function countThisPage() {
    var paths = readPaths();
    if (paths.indexOf(location.pathname) === -1) {
      paths.push(location.pathname);
      store(K.paths, JSON.stringify(paths));
    }
  }

  function check() {
    if (fired) return;
    var active = num(K.active);
    var pages = readPaths().length;
    if (debug) {
      console.log(
        '[honest_click progress] active ' + active + '/' + MIN_ACTIVE_SECONDS + 's, pages ' +
          pages + '/' + MIN_PAGES
      );
    }
    if (active >= MIN_ACTIVE_SECONDS && pages >= MIN_PAGES) send();
  }

  /* Any real sign the visitor is there, used for "active" time. */
  function touch() {
    lastActivity = Date.now();
  }
  ['scroll', 'wheel', 'touchstart', 'touchmove', 'pointerdown', 'pointermove', 'keydown', 'click'].forEach(
    function (type) {
      window.addEventListener(type, touch, { capture: true, passive: true });
    }
  );

  setInterval(function () {
    if (fired || store(ONCE_KEY)) return;
    if (document.visibilityState !== 'visible') return;
    if (Date.now() - lastActivity > IDLE_MS) return;
    store(K.active, String(num(K.active) + TICK_MS / 1000));
    check();
  }, TICK_MS);

  countThisPage();
  check();
})();
